import { Injectable } from '@angular/core';
import { Constants } from '../../util/constants';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Machine } from '../../models/machine.model';
import { User } from '../../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class MachineDataService {

  constructor(private http: HttpClient) { }

  	getMachines(clinicid: String, loggedUser:User): Observable<any> {
		var auth: string ='Bearer' + ' ' + loggedUser.Token
		const httpOptions = {
			headers: new HttpHeaders({ 
				 'authorization': auth
			})
		}
		return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/getmachines/' + clinicid,null , httpOptions).pipe()
    }
    
  	saveMachine(machine : Machine ,loggedUser:User): Observable<any> {
		var auth: string ='Bearer' + ' ' + loggedUser.Token
		const httpOptions = {
			headers: new HttpHeaders({ 
				 'authorization': auth,
				 'Accept': 'application/json',
				 'Content-type': 'application/json'
			})
        }
		 return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/savemachine',JSON.stringify(machine) , httpOptions).pipe()
	}

	getEquipments(loggedUser:User): Observable<any> {
		var auth: string ='Bearer' + ' ' + loggedUser.Token
		const httpOptions = {
	  headers: new HttpHeaders({ 
		'authorization': auth
	  })
		}
		return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/getequipments',null , httpOptions).pipe()
  	}

  	getmachinesbyclinicidandlocationid(clinicid: String, locationid: String, loggedUser:User): Observable<any> {
		var auth: string ='Bearer' + ' ' + loggedUser.Token
		const httpOptions = {
			headers: new HttpHeaders({ 
				'authorization': auth
			})
		}
		return this.http.post<any>(environment.server_URL+ environment.router_prefix + '/getmachinesbyclinicidandlocationid/' + clinicid + locationid,null , httpOptions).pipe()
	}
}
